import { z } from 'zod';

export const TIMELINE_FETCH_MODES = ['cached', 'auto', 'fresh'] as const;

export type TimelineFetchMode = (typeof TIMELINE_FETCH_MODES)[number];

export const TimelineFetchModeSchema = z.enum(TIMELINE_FETCH_MODES);
